const i = {
  "Africa/Abidjan": "+225",
  "Africa/Accra": "+233",
  "Africa/Addis_Ababa": "+251",
  "Africa/Algiers": "+213",
  "Africa/Asmara": "+291",
  "Africa/Bamako": "+223",
  "Africa/Bangui": "+236",
  "Africa/Banjul": "+220",
  "Africa/Bissau": "+245",
  "Africa/Blantyre": "+265",
  "Africa/Brazzaville": "+242",
  "Africa/Bujumbura": "+257",
  "Africa/Cairo": "+20",
  "Africa/Casablanca": "+212",
  "Africa/Ceuta": "+34",
  "Africa/Conakry": "+224",
  "Africa/Dakar": "+221",
  "Africa/Dar_es_Salaam": "+255",
  "Africa/Djibouti": "+253",
  "Africa/Douala": "+237",
  "Africa/El_Aaiun": "+212",
  "Africa/Freetown": "+232",
  "Africa/Gaborone": "+267",
  "Africa/Harare": "+263",
  "Africa/Johannesburg": "+27",
  "Africa/Juba": "+211",
  "Africa/Kampala": "+256",
  "Africa/Khartoum": "+249",
  "Africa/Kigali": "+250",
  "Africa/Kinshasa": "+243",
  "Africa/Lagos": "+234",
  "Africa/Libreville": "+241",
  "Africa/Lome": "+228",
  "Africa/Luanda": "+244",
  "Africa/Lubumbashi": "+243",
  "Africa/Lusaka": "+260",
  "Africa/Malabo": "+240",
  "Africa/Maputo": "+258",
  "Africa/Maseru": "+266",
  "Africa/Mbabane": "+268",
  "Africa/Mogadishu": "+252",
  "Africa/Monrovia": "+231",
  "Africa/Nairobi": "+254",
  "Africa/Ndjamena": "+235",
  "Africa/Niamey": "+227",
  "Africa/Nouakchott": "+222",
  "Africa/Ouagadougou": "+226",
  "Africa/Porto-Novo": "+229",
  "Africa/Sao_Tome": "+239",
  "Africa/Tripoli": "+218",
  "Africa/Tunis": "+216",
  "Africa/Windhoek": "+264",
  "America/Adak": "+1",
  "America/Anchorage": "+1",
  "America/Anguilla": "+1",
  "America/Antigua": "+1",
  "America/Araguaina": "+55",
  "America/Argentina/Buenos_Aires": "+54",
  "America/Buenos_Aires": "+54",
  "America/Argentina/Catamarca": "+54",
  "America/Argentina/Cordoba": "+54",
  "America/Argentina/Jujuy": "+54",
  "America/Argentina/La_Rioja": "+54",
  "America/Argentina/Mendoza": "+54",
  "America/Argentina/Rio_Gallegos": "+54",
  "America/Argentina/Salta": "+54",
  "America/Argentina/San_Juan": "+54",
  "America/Argentina/San_Luis": "+54",
  "America/Argentina/Tucuman": "+54",
  "America/Argentina/Ushuaia": "+54",
  "America/Aruba": "+297",
  "America/Asuncion": "+595",
  "America/Atikokan": "+1",
  "America/Bahia": "+55",
  "America/Bahia_Banderas": "+52",
  "America/Barbados": "+1",
  "America/Belem": "+55",
  "America/Belize": "+501",
  "America/Blanc-Sablon": "+1",
  "America/Boa_Vista": "+55",
  "America/Bogota": "+57",
  "America/Boise": "+1",
  "America/Cambridge_Bay": "+1",
  "America/Campo_Grande": "+55",
  "America/Cancun": "+52",
  "America/Caracas": "+58",
  "America/Cayenne": "+594",
  "America/Cayman": "+1",
  "America/Chicago": "+1",
  "America/Chihuahua": "+52",
  "America/Costa_Rica": "+506",
  "America/Creston": "+1",
  "America/Cuiaba": "+55",
  "America/Curacao": "+599",
  "America/Danmarkshavn": "+299",
  "America/Dawson": "+1",
  "America/Dawson_Creek": "+1",
  "America/Denver": "+1",
  "America/Detroit": "+1",
  "America/Dominica": "+1",
  "America/Edmonton": "+1",
  "America/Eirunepe": "+55",
  "America/El_Salvador": "+503",
  "America/Fort_Nelson": "+1",
  "America/Fortaleza": "+55",
  "America/Glace_Bay": "+1",
  "America/Goose_Bay": "+1",
  "America/Grand_Turk": "+1",
  "America/Grenada": "+1",
  "America/Guadeloupe": "+590",
  "America/Guatemala": "+502",
  "America/Guayaquil": "+593",
  "America/Guyana": "+592",
  "America/Halifax": "+1",
  "America/Havana": "+53",
  "America/Hermosillo": "+52",
  "America/Indiana/Indianapolis": "+1",
  "America/Indiana/Knox": "+1",
  "America/Indiana/Marengo": "+1",
  "America/Indiana/Petersburg": "+1",
  "America/Indiana/Tell_City": "+1",
  "America/Indiana/Vevay": "+1",
  "America/Indiana/Vincennes": "+1",
  "America/Indiana/Winamac": "+1",
  "America/Inuvik": "+1",
  "America/Iqaluit": "+1",
  "America/Jamaica": "+1",
  "America/Juneau": "+1",
  "America/Kentucky/Louisville": "+1",
  "America/Kentucky/Monticello": "+1",
  "America/Kralendijk": "+599",
  "America/La_Paz": "+591",
  "America/Lima": "+51",
  "America/Los_Angeles": "+1",
  "America/Louisville": "+1",
  "America/Lower_Princes": "+1",
  "America/Maceio": "+55",
  "America/Managua": "+505",
  "America/Manaus": "+55",
  "America/Marigot": "+590",
  "America/Martinique": "+596",
  "America/Matamoros": "+52",
  "America/Mazatlan": "+52",
  "America/Mendoza": "+1",
  "America/Menominee": "+1",
  "America/Merida": "+52",
  "America/Metlakatla": "+1",
  "America/Mexico_City": "+52",
  "America/Miquelon": "+508",
  "America/Moncton": "+1",
  "America/Monterrey": "+52",
  "America/Montevideo": "+598",
  "America/Montserrat": "+1",
  "America/Nassau": "+1",
  "America/New_York": "+1",
  "America/Nipigon": "+1",
  "America/Nome": "+1",
  "America/Noronha": "+55",
  "America/North_Dakota/Beulah": "+1",
  "America/North_Dakota/Center": "+1",
  "America/North_Dakota/New_Salem": "+1",
  "America/Nuuk": "+299",
  "America/Ojinaga": "+52",
  "America/Panama": "+507",
  "America/Pangnirtung": "+1",
  "America/Paramaribo": "+597",
  "America/Phoenix": "+1",
  "America/Port-au-Prince": "+509",
  "America/Port_of_Spain": "+1",
  "America/Porto_Velho": "+55",
  "America/Puerto_Rico": "+1",
  "America/Punta_Arenas": "+56",
  "America/Rainy_River": "+1",
  "America/Rankin_Inlet": "+1",
  "America/Recife": "+55",
  "America/Regina": "+1",
  "America/Resolute": "+1",
  "America/Rio_Branco": "+55",
  "America/Santarem": "+55",
  "America/Santiago": "+56",
  "America/Santo_Domingo": "+1",
  "America/Sao_Paulo": "+55",
  "America/Scoresbysund": "+299",
  "America/Sitka": "+1",
  "America/St_Barthelemy": "+590",
  "America/St_Johns": "+1",
  "America/St_Kitts": "+1",
  "America/St_Lucia": "+1",
  "America/St_Thomas": "+1",
  "America/St_Vincent": "+1",
  "America/Swift_Current": "+1",
  "America/Tegucigalpa": "+504",
  "America/Thule": "+299",
  "America/Thunder_Bay": "+1",
  "America/Tijuana": "+52",
  "America/Toronto": "+1",
  "America/Tortola": "+1",
  "America/Vancouver": "+1",
  "America/Whitehorse": "+1",
  "America/Winnipeg": "+1",
  "America/Yakutat": "+1",
  "America/Yellowknife": "+1",
  "Antarctica/Casey": "+672",
  "Antarctica/Davis": "+672",
  "Antarctica/DumontDUrville": "+672",
  "Antarctica/Macquarie": "+61",
  "Antarctica/Mawson": "+672",
  "Antarctica/McMurdo": "+64",
  "Antarctica/Palmer": "+56",
  "Antarctica/Rothera": "+672",
  "Antarctica/Syowa": "+672",
  "Antarctica/Troll": "+47",
  "Antarctica/Vostok": "+672",
  "Arctic/Longyearbyen": "+47",
  "Asia/Aden": "+967",
  "Asia/Almaty": "+7",
  "Asia/Amman": "+962",
  "Asia/Anadyr": "+7",
  "Asia/Aqtau": "+7",
  "Asia/Aqtobe": "+7",
  "Asia/Ashgabat": "+993",
  "Asia/Atyrau": "+7",
  "Asia/Baghdad": "+964",
  "Asia/Bahrain": "+973",
  "Asia/Baku": "+994",
  "Asia/Bangkok": "+66",
  "Asia/Barnaul": "+7",
  "Asia/Beirut": "+961",
  "Asia/Bishkek": "+996",
  "Asia/Brunei": "+673",
  "Asia/Calcutta": "+91",
  "Asia/Chita": "+7",
  "Asia/Choibalsan": "+976",
  "Asia/Colombo": "+94",
  "Asia/Damascus": "+963",
  "Asia/Dhaka": "+880",
  "Asia/Dili": "+670",
  "Asia/Dubai": "+971",
  "Asia/Dushanbe": "+992",
  "Asia/Famagusta": "+357",
  "Asia/Gaza": "+970",
  "Asia/Hebron": "+970",
  "Asia/Ho_Chi_Minh": "+84",
  "Asia/Hong_Kong": "+852",
  "Asia/Hovd": "+976",
  "Asia/Irkutsk": "+7",
  "Asia/Jakarta": "+62",
  "Asia/Jayapura": "+62",
  "Asia/Jerusalem": "+972",
  "Asia/Kabul": "+93",
  "Asia/Kamchatka": "+7",
  "Asia/Karachi": "+92",
  "Asia/Kathmandu": "+977",
  "Asia/Khandyga": "+7",
  "Asia/Kolkata": "+91",
  "Asia/Krasnoyarsk": "+7",
  "Asia/Kuala_Lumpur": "+60",
  "Asia/Kuching": "+60",
  "Asia/Kuwait": "+965",
  "Asia/Macau": "+853",
  "Asia/Magadan": "+7",
  "Asia/Makassar": "+62",
  "Asia/Manila": "+63",
  "Asia/Muscat": "+968",
  "Asia/Nicosia": "+357",
  "Asia/Novokuznetsk": "+7",
  "Asia/Novosibirsk": "+7",
  "Asia/Omsk": "+7",
  "Asia/Oral": "+7",
  "Asia/Phnom_Penh": "+855",
  "Asia/Pontianak": "+62",
  "Asia/Pyongyang": "+850",
  "Asia/Qatar": "+974",
  "Asia/Qostanay": "+7",
  "Asia/Qyzylorda": "+7",
  "Asia/Rangoon": "+95",
  "Asia/Riyadh": "+966",
  "Asia/Saigon": "+84",
  "Asia/Sakhalin": "+7",
  "Asia/Samarkand": "+998",
  "Asia/Seoul": "+82",
  "Asia/Shanghai": "+86",
  "Asia/Singapore": "+65",
  "Asia/Srednekolymsk": "+7",
  "Asia/Taipei": "+886",
  "Asia/Tashkent": "+998",
  "Asia/Tbilisi": "+995",
  "Asia/Tehran": "+98",
  "Asia/Thimphu": "+975",
  "Asia/Tokyo": "+81",
  "Asia/Tomsk": "+7",
  "Asia/Ulaanbaatar": "+976",
  "Asia/Urumqi": "+86",
  "Asia/Ust-Nera": "+7",
  "Asia/Vientiane": "+856",
  "Asia/Vladivostok": "+7",
  "Asia/Yakutsk": "+7",
  "Asia/Yekaterinburg": "+7",
  "Asia/Yerevan": "+374",
  "Atlantic/Azores": "+351",
  "Atlantic/Bermuda": "+1",
  "Atlantic/Canary": "+34",
  "Atlantic/Cape_Verde": "+238",
  "Atlantic/Faroe": "+298",
  "Atlantic/Madeira": "+351",
  "Atlantic/Reykjavik": "+354",
  "Atlantic/South_Georgia": "+500",
  "Atlantic/St_Helena": "+290",
  "Atlantic/Stanley": "+500",
  "Australia/Adelaide": "+61",
  "Australia/Brisbane": "+61",
  "Australia/Broken_Hill": "+61",
  "Australia/Darwin": "+61",
  "Australia/Eucla": "+61",
  "Australia/Hobart": "+61",
  "Australia/Lindeman": "+61",
  "Australia/Lord_Howe": "+61",
  "Australia/Melbourne": "+61",
  "Australia/Perth": "+61",
  "Australia/Sydney": "+61",
  "Europe/Amsterdam": "+31",
  "Europe/Andorra": "+376",
  "Europe/Astrakhan": "+7",
  "Europe/Athens": "+30",
  "Europe/Belgrade": "+381",
  "Europe/Berlin": "+49",
  "Europe/Bratislava": "+421",
  "Europe/Brussels": "+32",
  "Europe/Bucharest": "+40",
  "Europe/Budapest": "+36",
  "Europe/Busingen": "+41",
  "Europe/Chisinau": "+373",
  "Europe/Copenhagen": "+45",
  "Europe/Dublin": "+353",
  "Europe/Gibraltar": "+350",
  "Europe/Guernsey": "+44",
  "Europe/Helsinki": "+358",
  "Europe/Isle_of_Man": "+44",
  "Europe/Istanbul": "+90",
  "Europe/Jersey": "+44",
  "Europe/Kaliningrad": "+7",
  "Europe/Kyiv": "+380",
  "Europe/Kiev": "+380",
  "Europe/Kirov": "+7",
  "Europe/Lisbon": "+351",
  "Europe/Ljubljana": "+386",
  "Europe/London": "+44",
  "Europe/Luxembourg": "+352",
  "Europe/Madrid": "+34",
  "Europe/Malta": "+356",
  "Europe/Mariehamn": "+358",
  "Europe/Minsk": "+375",
  "Europe/Monaco": "+377",
  "Europe/Moscow": "+7",
  "Europe/Oslo": "+47",
  "Europe/Paris": "+33",
  "Europe/Podgorica": "+382",
  "Europe/Prague": "+420",
  "Europe/Riga": "+371",
  "Europe/Rome": "+39",
  "Europe/Samara": "+7",
  "Europe/San_Marino": "+378",
  "Europe/Sarajevo": "+387",
  "Europe/Saratov": "+7",
  "Europe/Simferopol": "+7",
  "Europe/Skopje": "+389",
  "Europe/Sofia": "+359",
  "Europe/Stockholm": "+46",
  "Europe/Tallinn": "+372",
  "Europe/Tirane": "+355",
  "Europe/Ulyanovsk": "+7",
  "Europe/Vaduz": "+423",
  "Europe/Vatican": "+39",
  "Europe/Vienna": "+43",
  "Europe/Vilnius": "+370",
  "Europe/Volgograd": "+7",
  "Europe/Warsaw": "+48",
  "Europe/Zagreb": "+385",
  "Europe/Zurich": "+41",
  "Indian/Antananarivo": "+261",
  "Indian/Chagos": "+246",
  "Indian/Christmas": "+61",
  "Indian/Cocos": "+61",
  "Indian/Comoro": "+269",
  "Indian/Kerguelen": "+262",
  "Indian/Mahe": "+248",
  "Indian/Maldives": "+960",
  "Indian/Mauritius": "+230",
  "Indian/Mayotte": "+262",
  "Indian/Reunion": "+262",
  "Pacific/Apia": "+685",
  "Pacific/Auckland": "+64",
  "Pacific/Bougainville": "+675",
  "Pacific/Chatham": "+64",
  "Pacific/Chuuk": "+691",
  "Pacific/Easter": "+56",
  "Pacific/Efate": "+678",
  "Pacific/Enderbury": "+686",
  "Pacific/Fakaofo": "+690",
  "Pacific/Fiji": "+679",
  "Pacific/Funafuti": "+688",
  "Pacific/Galapagos": "+593",
  "Pacific/Gambier": "+689",
  "Pacific/Guadalcanal": "+677",
  "Pacific/Guam": "+1",
  "Pacific/Honolulu": "+1",
  "Pacific/Kiritimati": "+686",
  "Pacific/Kosrae": "+691",
  "Pacific/Kwajalein": "+692",
  "Pacific/Majuro": "+692",
  "Pacific/Marquesas": "+689",
  "Pacific/Midway": "+1",
  "Pacific/Nauru": "+674",
  "Pacific/Niue": "+683",
  "Pacific/Norfolk": "+672",
  "Pacific/Noumea": "+687",
  "Pacific/Pago_Pago": "+1",
  "Pacific/Palau": "+680",
  "Pacific/Pitcairn": "+64",
  "Pacific/Pohnpei": "+691",
  "Pacific/Port_Moresby": "+675",
  "Pacific/Rarotonga": "+682",
  "Pacific/Saipan": "+1",
  "Pacific/Tahiti": "+689",
  "Pacific/Tarawa": "+686",
  "Pacific/Tongatapu": "+676",
  "Pacific/Wake": "+1",
  "Pacific/Wallis": "+681"
}, r = (a) => i[a] || null;
export {
  r as getPhoneCodeByTimezone
};
